import validate from "/var/www/hladamchatu.sk/nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "guest-only": () => import("/var/www/hladamchatu.sk/nuxt/middleware/guest-only.ts"),
  "user-only": () => import("/var/www/hladamchatu.sk/nuxt/middleware/user-only.ts")
}